<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <Form
      :addNewData="openModal"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      :editMode="editMode"
      :dataBrand="dataBrand"
      :dataEdit="dataEdit"
      :title="titleModal"
      :allData="data"></Form>

    <DeleteConfirmation
      :isOpen="confirmDelete"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      :id="id"
      :type="type"
      :title="titleModal"></DeleteConfirmation>

    <vs-table ref="table" v-if="refresh" :max-items="itemsPerPage" :data="data">
      <template
        #header
        class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNew()">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ $t('Add New') }}</span>
          </div>

          <div class="hidden" style="position: absolute; right: 0; top: 4px">
            <vs-input
              class="float-left mr-2"
              placeholder="Search"
              name="name"
              v-model="search" />
            <vs-button
              type="gradient"
              :disabled="search == ''"
              class="shadow-lg float-left"
              style="width: 50px; padding: 10px !important"
              color="#d23030"
              gradient-color-secondary="#f89595"
              @click="filterData()">
              <feather-icon
                svgClasses="h-4 w-4"
                class="cursor-pointer"
                icon="SearchIcon"></feather-icon>
            </vs-button>
          </div>
        </div>
        <!-- ITEMS PER PAGE -->
      </template>
      <template #thead>
        <vs-th sort-key="vehicle_model">{{ $t('VEHICLE MODEL') }}</vs-th>
        <!-- <vs-th sort-key="status">STATUS</vs-th> -->
        <vs-th sort-key="action">{{ $t('ACTION') }}</vs-th>
      </template>

      <template v-slot="{ data }">
        <tbody id="isi_table">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].vehicle_model" class="w-2/3">
              <p class="product-name font-medium">
                {{ tr.model_name }}
              </p>
            </vs-td>
            <vs-td>
              <div class="flex flex-row justify-between" style="gap: 10px">
                <vs-button
                  color="primary"
                  type="border"
                  class="py-2 px-3"
                  @click="handleSelected(tr)">
                  <div
                    class="flex flex-row items-center justify-between"
                    style="gap: 5px">
                    <feather-icon icon="EditIcon" svgClasses="h-4 w-4" />
                    <p class="mx-4">{{ $t('Edit') }}</p>
                  </div>
                </vs-button>
                <vs-button
                  color="danger"
                  radius
                  type="flat"
                  @click="deleteModel(tr)">
                  <feather-icon icon="Trash2Icon" svgClasses="h-6 w-6" />
                  <!-- <p>Edit</p> -->
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <template v-if="refresh">
      <vs-pagination :total="last_page" v-model="page"></vs-pagination>
    </template>
  </div>
</template>

<script>
import Form from './VehicleModelForm.vue'
import DeleteConfirmation from './DeleteConfirmation.vue'
import * as REPO from '../../../repository/index'
import * as moment from 'moment'

export default {
  components: {
    Form,
    DeleteConfirmation,
  },
  data() {
    return {
      id: '',
      openModal: false,
      openBulkModal: false,
      editMode: false,
      refresh: false,
      confirmDelete: false,
      type: 'model',
      titleModal: 'Add New',
      selected: [],
      alertData: [],
      dataModel: [],
      dataBrand: [],
      dataEndPoints: [],

      search: '',
      itemsPerPage: 10,
      last_page: 1,
      page: 1,
      fleetGroupData: [],
      dataEdit: {},
      data: [],
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  watch: {
    selected_filter(val) {
      //
      if (val == 'all') {
        let param = { page: 1 }
        this.dataNew(param)
      }
    },
    page(val) {
      let param = { page: this.page }
      // if (this.selected_filter === 'license_plate') {
      //   param = {
      //     page: this.page,
      //     license_plate: this.search,
      //   }
      // }
      // if (this.selected_filter === 'imei_obd_number') {
      //   param = {
      //     page: this.page,
      //     imei: this.search,
      //   }
      // }
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.dataNew(param)
    },
  },
  methods: {
    async filterData() {
      this.refresh = false
      setTimeout(() => {
        this.refresh = true
        this.$nextTick(() => {
          this.$vs.loading({
            container: '#isi_table',
            scale: 1,
          })
          let param = { page: 1 }
          // if (this.selected_filter === 'license_plate') {
          //   param = {
          //     page: 1,
          //     license_plate: this.search,
          //   }
          // }
          // if (this.selected_filter === 'imei_obd_number') {
          //   param = {
          //     page: 1,
          //     imei: this.search,
          //   }
          // }
          // if (this.selected_filter === 'all') {
          //   param = {
          //     page: 1,
          //   }
          // }
          // })
        })
      }, 200)
    },
    dataNew(param) {
      REPO.getListModel(param)
        .then((res) => {
          let tmp = res.data.data.data
          this.last_page = res.data.data.last_page
          this.data = tmp
          this.$vs.loading.close('#isi_table > .con-vs-loading')
        })
        .catch((err) => {
          // alert(err)
          this.$vs.loading.close('#isi_table > .con-vs-loading')

          this.$toast.error(error.message)
        })
    },
    formatDate(val) {
      return moment(val).format('DD MMMM YYYY')
    },
    addNew() {
      this.editMode = false
      this.titleModal = 'Add New Model'
      // this.dataEdit = {};
      this.openModal = true
    },
    getData() {
      REPO.getListModel()
        .then((res) => {
          // this.dataModel = res.data.data
          const tmp = res.data.data
          //
          this.data = tmp
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        })
        .catch((err) => {
          //
        })

      REPO.getListBrand()
        .then((res) => {
          this.dataBrand = res.data.data
        })
        .catch((err) => {
          //
        })
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    handleSelected(tr) {
      //
      this.editMode = true
      this.titleModal = 'Update Data'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.openModal = true
    },
    closeModal() {
      this.openModal = false
      this.editMode = false
      this.openBulkModal = false
      this.confirmDelete = false
    },
    submitModal() {
      this.openModal = false
      this.editMode = false
      this.openBulkModal = false
      this.getData()
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    deleteModel(tr) {
      //
      this.titleModal = 'Delete Data'
      // this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.id = tr.id
      this.confirmDelete = true
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    this.filter_array = [
      {
        text: '>> Reset Filter',
        value: 'all',
      },
      {
        text: 'License Plate',
        value: 'license_plate',
      },
      {
        text: 'IMEI',
        value: 'imei_obd_number',
      },
    ]
    this.refresh = true
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    this.isMounted = true
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
